module.exports = __webpack_public_path__ + "img/other03.26ae00cf.png";